import { idccAutoriseTT } from '@/features/domaine/regles-akto/shared'
import { storeToRefs } from 'pinia'
import { computed, type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'
import { useDemandeCARStore } from './useDemandeCARStore'

type DemandeCARActions = ReturnType<typeof useDemandeCARActions>
export const CAR_ACTIONS: InjectionKey<DemandeCARActions> = Symbol('car-actions')

export function useDemandeCARActions() {
  const store = useDemandeCARStore()

  const { model } = storeToRefs(store)

  const actionsDemande = buildDemandeActions({
    store: store as any,
    typeDocumentTemplate: computed(() => null),
  })

  const estTypePublicVisible = computed(() => {
    const idcc = model.value?.employeur?.etablissement?.idcc?.code
    return idccAutoriseTT.includes(idcc ?? '')
  })

  return {
    ...actionsDemande,
    estTypePublicVisible,
  }
}
